import { render, staticRenderFns } from "./ClearFilters.vue?vue&type=template&id=0585d964"
import script from "./ClearFilters.vue?vue&type=script&lang=js"
export * from "./ClearFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports